export const API_TOKEN_COOKIE = "apiAccessToken";
export const SKIPPED_TOURS_LS_KEY = "EMMS_SkippedTours";
// idexport s from EncoderProfile table:
export const ID_MP4_H264_270P = 5;
export const ID_MP4_H264_480P = 6;
export const ID_MP4_H264_720P = 7;
export const ID_MP4_H264_1080P = 15;

export const encoderProfilesNames = {
  [ID_MP4_H264_270P]: "MP4 H.264 270p",
  [ID_MP4_H264_480P]: "MP4 H.264 480p",
  [ID_MP4_H264_720P]: "MP4 H.264 720p",
  [ID_MP4_H264_1080P]: "MP4 H.264 1080p"
};

export const CDN_TYPE_INTERNAP = "internap";
export const CDN_TYPE_LIMELIGHT = "limelight";
export const CDN_TYPE_AKAMAI = "akamai";

export const DRM_VENDOR_BUYDRM = "buydrm";

export const ENVIRONMENT_TEST = "test";
export const ENVIRONMENT_LIVE = "live";

export const GATEWAY_TYPE_AUTHORIZE = "PaymentGatewayAuthorize";
export const GATEWAY_TYPE_PAYPAL = "PaymentGatewayPaypal";
export const GATEWAY_TYPE_TPAY = "PaymentGatewayTpay";
export const GATEWAY_TYPE_ITUNES = "PaymentGatewayItunes";
export const GATEWAY_TYPE_STRIPE = "PaymentGatewayStripe";
export const GATEWAY_TYPE_ROKU = "PaymentGatewayRoku";
export const GATEWAY_TYPE_AMAZON = "PaymentGatewayAmazon";
export const GATEWAY_TYPE_GOOGLE = "PaymentGatewayGooglePlay";

export const GATEWAY_NAME_AUTHORIZE = "Authorize.Net";
export const GATEWAY_NAME_PAYPAL = "PayPal";
export const GATEWAY_NAME_TPAY = "TPAY";
export const GATEWAY_NAME_ITUNES = "Apple";
export const GATEWAY_NAME_STRIPE = "Stripe";
export const GATEWAY_NAME_ROKU = "Roku";
export const GATEWAY_NAME_AMAZON = "Amazon";
export const GATEWAY_NAME_GOOGLE = "Google";

export const PAGE_LIMIT = 20;

export const SUPPORT_EMAIL = "support@endavomedia.com";

export const DEFAULT_TOASTER_ERROR_MESSAGE =
  "Something went wrong. We will look into the matter and fix it as soon as possible.";

// user roles needed
export const ROLE_USER_REGULAR = [
  "ROLE_USER_REGULAR",
  "ROLE_USER_ADMIN",
  "ROLE_USER_GROUP_ADMIN",
  "ROLE_USER_SUPER_ADMIN"
];
export const ROLE_USER_FINANCE = [
  "ROLE_USER_FINANCE",
  "ROLE_USER_ADMIN",
  "ROLE_USER_GROUP_ADMIN",
  "ROLE_USER_SUPER_ADMIN"
];
export const ROLE_USER_SCHEDULER = [
  "ROLE_USER_SCHEDULER",
  "ROLE_USER_ADMIN",
  "ROLE_USER_GROUP_ADMIN",
  "ROLE_USER_SUPER_ADMIN"
];
export const ROLE_USER_MODERATOR = [
  "ROLE_USER_MODERATOR",
  "ROLE_USER_ADMIN",
  "ROLE_USER_GROUP_ADMIN",
  "ROLE_USER_SUPER_ADMIN"
];
export const ROLE_USER_SEO = [
  "ROLE_USER_SEO",
  "ROLE_USER_ADMIN",
  "ROLE_USER_GROUP_ADMIN",
  "ROLE_USER_SUPER_ADMIN"
];
export const ROLE_USER_ADMIN = [
  "ROLE_USER_ADMIN",
  "ROLE_USER_GROUP_ADMIN",
  "ROLE_USER_SUPER_ADMIN"
];
export const ROLE_USER_GROUP_ADMIN = [
  "ROLE_USER_GROUP_ADMIN",
  "ROLE_USER_SUPER_ADMIN"
];
export const ROLE_USER_SUPER_ADMIN = "ROLE_USER_SUPER_ADMIN";

export const GOOGLE_API_BASE_URL = "https://maps.googleapis.com/maps/api";

export const DEFAULT_TIME_ZONE = "America/New_York";

// Stripe subscription statuses

export const SUBSCRIPTION_STATUS_ACTIVE = "Active";
export const SUBSCRIPTION_STATUS_CANCELED = "Canceled";
export const SUBSCRIPTION_STATUS_TRIALING = "Trialing";
export const SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED = "Incomplete Expired";
export const SUBSCRIPTION_STATUS_UNPAID = "Unpaid";

// Subscription prices

export const OTT_CHANNEL_SUBSCRIPTION_BASE_PRICE = 199;

// Endavo community statuses

export const COMMUNITY_STATUS_CANCELED = "canceled";
export const COMMUNITY_STATUS_TRIAL = "trial";
export const COMMUNITY_STATUS_DELETED = "deleted";
export const COMMUNITY_STATUS_UNPAID = "unpaid";
export const COMMUNITY_STATUS_ACTIVE = "active";
export const COMMUNITY_STATUS_SUSPENDED = "suspended";

// Community Plans

export const OTT_CHANNEL_PLAN = "ottChannel";

// Community Types

export const COMMUNITY_TYPE_CHANNEL_PARTNER = "channelPartner";
export const COMMUNITY_TYPE_REGULAR = "regular";

// Social Network Types
export const SOCIAL_NETWORKS_TYPE_FACEBOOK_USER = "facebookUser";
export const SOCIAL_NETWORKS_TYPE_FACEBOOK_PAGE = "facebookPage";
export const SOCIAL_NETWORKS_TYPE_FACEBOOK_GROUP = "facebookGroup";
export const SOCIAL_NETWORKS_TYPE_TWITTER = "twitter";
export const SOCIAL_NETWORKS_TYPE_YOUTUBE = "youtube";
export const SOCIAL_NETWORKS_TYPE_VIMEO = "vimeo";

// Platform types

export const PLATFORM_TYPE_COBRA = "cobra";
export const PLATFORM_TYPE_ANDROID = "android";
export const PLATFORM_TYPE_ANDROID_TV = "androidTv";
export const PLATFORM_TYPE_GOOGLE_TV = "googleTv";
export const PLATFORM_TYPE_IOS = "iOS";
export const PLATFORM_TYPE_TVOS = "tvOS";
export const PLATFORM_TYPE_ROKU = "roku";
export const PLATFORM_TYPE_CUSTOM = "custom";
export const PLATFORM_TYPE_EMBED_PLAYER = "embedPlayer";

// appBuilder menu items types Grid, List, Dropdown, External, Static, Item

export const APP_MENU_ITEM_TYPE_CONTENT = "contentScreen";
export const APP_MENU_ITEM_TYPE_DROPDOWN = "dropdownList";
export const APP_MENU_ITEM_TYPE_INTERNAL_ITEM = "internalItem";
export const APP_MENU_ITEM_TYPE_EXTERNAL_LINK = "externalLink";

// app screen types

export const APP_SCREEN_TYPE_TEXT = "text";
export const APP_SCREEN_TYPE_BANNERS = "bannerGroup";
export const APP_SCREEN_TYPE_JS_SNIPPET = "javascriptSnippet";
export const APP_SCREEN_TYPE_LIST = "list";

export const SCREEN_SUBTYPE_VIDEOS = "videos";
export const SCREEN_SUBTYPE_VIDEOS_EPISODES = "videosAndEpisodes";
export const SCREEN_SUBTYPE_EPISODES = "episodes";
export const SCREEN_SUBTYPE_COMBINED = "combined";
export const SCREEN_SUBTYPE_SERIES = "series";
export const SCREEN_SUBTYPE_CHANNELS = "channels";
export const SCREEN_SUBTYPE_CATEGORIES = "categories";

// Media provider types

export const MEDIA_PROVIDERTYPE_CONTENTOWNER = "Account Media";
export const MEDIA_PROVIDERTYPE_MEMBERUPLOADED = "memberUploaded";
export const MEDIA_PROVIDERTYPE_RSS = "rss";
export const MEDIA_PROVIDERTYPE_INTERNAL_SYNDICATION = "internalSyndication";
export const MEDIA_PROVIDERTYPE_RECORDED_EVENT = "recordedEvent";
export const MEDIA_PROVIDERTYPE_RECORDED_LIVE_STREAM = "recordedLiveStream";

// Media types

export const MEDIA_TYPE_LIVE_CHANNEL = "liveChannel";
export const MEDIA_TYPE_LIVE_EVENT = "liveEvent";
export const MEDIA_TYPE_VIRTUAL_LIVE_CHANNEL = "virtualLiveChannel";
export const MEDIA_TYPE_VIRTUAL_LIVE_EVENT = "virtualLiveEvent";
export const MEDIA_TYPE_VIDEO = "video";
export const MEDIA_TYPE_AUDIO = "audio";

// Media Format types

export const FORMAT_TYPE_FLV = "video:flv";
export const FORMAT_TYPE_M4V_H264 = "video:m4v_h264";
export const FORMAT_TYPE_MP4_H264_ORIGINAL = "video:mp4_h264:original";
export const FORMAT_TYPE_MP4_H264_270P = "video:mp4_h264:270p";
export const FORMAT_TYPE_MP4_H264_480P = "video:mp4_h264:480p";
export const FORMAT_TYPE_MP4_H264_720P = "video:mp4_h264:720p";
export const FORMAT_TYPE_MP4_H264_1080P = "video:mp4_h264:1080p";
export const FORMAT_TYPE_HLS_ENCRYPTED_BASELINE31 = "video:hls:baseline31";
export const FORMAT_TYPE_MOV = "video:mov";
export const FORMAT_TYPE_MP3 = "audio:mp3";
export const FORMAT_TYPE_M4A = "audio:mp4";
export const FORMAT_TYPE_PP_LIVE = "live";
export const FORMAT_TYPE_MKV_H264_ORIGINAL = "video:mkv_h264:original";
export const FORMAT_TYPE_MKV_NONH264_ORIGINAL = "video:mkv_nonh264:original";
export const FORMAT_TYPE_HLS_STANDARD_BASELINE31 = "video:hls:standard31"; // self created RE-check with Dani !

export const userRoleLabels = {
  ROLE_USER_REGULAR: "Content Manager",
  ROLE_USER_FINANCE: "Finance",
  ROLE_USER_SEO: "Marketing",
  ROLE_USER_MODERATOR: "Moderator",
  ROLE_USER_SCHEDULER: "VLC/VLE Scheduler"
};

export const RENTAL_PLAN_TYPES = {
  vod: "Video On Demand",
  liveEvent: "Live Event"
};

export const DEFAULT_KB_ICON_TOOLTIP_TEXT =
  "Click to learn more in our Knowledge Base.";

export const DEFAULT_KB_ICON_CLASSNAME = "fas fa-book-open";

export const KNOWLEDGE_BASE_ROOT_URL =
  "https://help.endavomedia.com/knowledge/";

export const STREAMING_FAITH_GROUP_ID =
  process.env.REACT_APP_STAGE === "production" ? "11" : "28";
export const PIKSEL_GROUP_ID = "12";
export const ENDAVO_GROUP_ID = "1";
export const IMPACT_NETWORK_GROUP_ID = "24";
export const BLUE_PIKSEL_GROUP_ID = "25";

export const SUPPORTTED_VIDEO_FORMATS = [
  ".wmv",
  ".flv",
  ".ts",
  ".mp4",
  ".m4v",
  ".mkv",
  ".avi",
  ".asf",
  ".mpg",
  ".mpeg",
  ".mov",
  ".mxf"
];

export const SUPPORTED_AUDIO_FORMATS = [".mp3", ".m4a"];

export const MEDIA_PLAY_DISABLED_TOOLTIP =
  "Media cannot be played at that time.";

export const BYTE_MULTIPLIER = 1000;
export const DATA_SIZE_UNITS = ["B", "KB", "MB", "GB", "TB", "PB"];
export const TABLE_STATE_PARAMS = ["page", "orderBy", "orderDirection"];
